(function () {
  var MOBILE_MAX = 991;
  var CLOSE_MS = 400;
  var panel = null;
  var toggle = null;
  var open = false;
  var scrollY = 0;
  var rafId = null;
  var unlockTimer = null;
  var vvHandler = null;

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  function getAnchor() {
    var mobileAnchor = document.querySelector('[data-mobile-nav-anchor]');
    if (!mobileAnchor) return document.querySelector('[data-mobile-nav-header]');

    var style = window.getComputedStyle(mobileAnchor);
    if (style.display !== 'none' && style.visibility !== 'hidden') {
      return mobileAnchor;
    }

    return document.querySelector('[data-mobile-nav-header]');
  }

  function getVisibleBottom() {
    var vv = window.visualViewport;
    return vv ? vv.offsetTop + vv.height : window.innerHeight;
  }

  function updatePanelHeight() {
    if (!isMobile()) return;

    var anchor = getAnchor();
    if (!panel || !anchor) return;

    var top = anchor.getBoundingClientRect().bottom;
    panel.style.top = top + 'px';

    if (!open) return;

    var height = Math.max(200, Math.ceil(getVisibleBottom() - top));
    panel.style.height = height + 'px';
  }

  function collapsePanelHeight() {
    if (!panel) return;
    panel.style.height = '0px';
  }

  function startHeightWatch() {
    stopHeightWatch();
    updatePanelHeight();
    if (!isMobile()) return;

    function loop() {
      if (!open) return;
      updatePanelHeight();
      rafId = requestAnimationFrame(loop);
    }
    rafId = requestAnimationFrame(loop);
  }

  function stopHeightWatch() {
    if (rafId) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
  }

  function cancelUnlockTimer() {
    if (unlockTimer) {
      clearTimeout(unlockTimer);
      unlockTimer = null;
    }
  }

  function lockScroll() {
    if (!isMobile()) return;
    cancelUnlockTimer();
    scrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('mobile-nav-open');
    document.body.classList.add('mobile-nav-open');
    document.body.style.top = '-' + scrollY + 'px';
  }

  function unlockScroll() {
    if (!document.body.classList.contains('mobile-nav-open')) return;
    cancelUnlockTimer();
    document.documentElement.classList.remove('mobile-nav-open');
    document.body.classList.remove('mobile-nav-open');
    document.body.style.removeProperty('top');
    window.scrollTo(0, scrollY);
  }

  function scheduleUnlockAfterClose() {
    cancelUnlockTimer();
    unlockTimer = window.setTimeout(function () {
      unlockTimer = null;
      if (!open) unlockScroll();
    }, CLOSE_MS);
  }

  function setOpenState(nextOpen) {
    if (!isMobile()) return;

    open = nextOpen;
    if (!panel || !toggle) return;

    if (open) {
      cancelUnlockTimer();
      panel.classList.add('is-open');
      panel.removeAttribute('inert');
      panel.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Menü schließen');
      toggle.classList.add('w--open');
      updatePanelHeight();
      panel.style.height = '0px';
      lockScroll();
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (!open) return;
          updatePanelHeight();
        });
      });
      startHeightWatch();
      window.setTimeout(updatePanelHeight, 50);
      window.setTimeout(updatePanelHeight, CLOSE_MS);
      return;
    }

    panel.classList.remove('is-open');
    panel.setAttribute('inert', '');
    panel.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Menü öffnen');
    toggle.classList.remove('w--open');
    stopHeightWatch();
    updatePanelHeight();
    collapsePanelHeight();
    scheduleUnlockAfterClose();
  }

  function toggleMenu() {
    if (!isMobile()) return;
    setOpenState(!open);
  }

  function closeMenu() {
    if (open) setOpenState(false);
  }

  function onPanelClick(event) {
    if (!isMobile() || !panel || !panel.contains(event.target)) return;

    if (event.target.closest('a[href]')) {
      closeMenu();
      return;
    }

    if (event.target.closest('button[type="submit"]')) {
      return;
    }

    var trigger = event.target.closest('[data-mobile-nav-accordion]');
    if (!trigger) return;

    var item = trigger.closest('[data-mobile-nav-item]');
    if (!item) return;

    var targetPanel = trigger.nextElementSibling;
    if (!targetPanel || !targetPanel.hasAttribute('data-mobile-nav-panel')) {
      targetPanel = item.querySelector('[data-mobile-nav-panel]');
    }
    if (!targetPanel) return;

    event.preventDefault();
    event.stopPropagation();

    var icon = trigger.querySelector('.dropdown-icon');
    targetPanel.classList.toggle('is-open');
    if (icon) icon.classList.toggle('is-open');
  }

  function onKeydown(event) {
    if (event.key === 'Escape' && open) closeMenu();
  }

  function bindViewport() {
    vvHandler = function () {
      if (!isMobile() && open) {
        closeMenu();
        return;
      }
      if (open) updatePanelHeight();
    };
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', vvHandler);
      window.visualViewport.addEventListener('scroll', vvHandler);
    }
    window.addEventListener('resize', vvHandler);
    window.addEventListener('orientationchange', function () {
      window.setTimeout(function () {
        if (!isMobile() && open) closeMenu();
        else if (open) updatePanelHeight();
      }, 100);
    });
  }

  function cacheElements() {
    panel = document.getElementById('mobile-nav-panel');
    toggle = document.getElementById('mobile-nav-toggle');
  }

  function bind() {
    cacheElements();
    if (!panel || !toggle) return;

    toggle.addEventListener('click', function (event) {
      if (!isMobile()) return;
      event.preventDefault();
      event.stopPropagation();
      toggleMenu();
    });

    panel.addEventListener('click', onPanelClick);

    document.addEventListener('click', function (event) {
      if (!open || !isMobile()) return;
      if (panel.contains(event.target) || toggle.contains(event.target)) return;
      closeMenu();
    });

    document.addEventListener('keydown', onKeydown);
    bindViewport();
  }

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bind);
    } else {
      bind();
    }

    document.addEventListener('shopify:section:load', function () {
      if (open) closeMenu();
      cacheElements();
    });
  }

  init();
})();
